import styled from 'styled-components';

export const Subtitulo = styled.span`
color: var(--primary);
text-decoration: underline;
`;